import {TreatmentTarget} from './treatment_target'
export class HuntOrderTreatment extends TreatmentTarget {
  constructor() {
    super();
  }

  addNewItem() {
   let newRank = this.querySelectorAll('.hunt_ordered_form_group .hunt_ordered_form_item').length + 1;
   let newHuntOrderItem = document.createElement('hunt-order-item');
   this.querySelector('.hunt_ordered_form_group').appendChild(newHuntOrderItem);
   newHuntOrderItem.setRank(newRank);
  }

  rerank() {
    this.querySelectorAll('hunt-order-item').forEach((item, index) => item.setRank(index+1));
  }

  validate() {
    let response = {}
    this.querySelectorAll('input').forEach((input) => { 
      input.classList.remove("error")
      if(input.value === "") {
        input.classList.add("error")
        response.requiredMissing = true 
      }
    });
    return response;
  }

  static getType() {
    return "HUNT_ORDER"
  }

  getData() {
    let target = 
      { 
        target_name: "HUNT_ORDER",
        target_type: "HUNT_ORDER", 
        ring_to_endpoint: null,
        ivr_target_audio_id: null,
        ivr_choice_timeout: null,
        children: [],
        actions: []
      }

    this.querySelectorAll("hunt-order-item").forEach(function(hunt_order_item, index) {
      let ring_to_endpoint = hunt_order_item.querySelector("input.hunt_ordered_ring_number").value;
      let child = {
        ivr_option: null, 
        ivr_option: null, 
        tod_rank: index+1,
        tod_day_map: 127, // bitmap of 7 days a week.
        tod_start_time: "0000",
        tod_end_time: "2400",
        tod_rna_rollover: hunt_order_item.querySelector("input.hunt_ordered_rna").value,
        destination: { 
          target_name: `Ring ${ring_to_endpoint}`,
          target_type: "ENDPOINT", 
          ring_to_endpoint: ring_to_endpoint,
          ivr_target_audio_id: null,
          ivr_choice_timeout: null,
          children: []
        }
      }
      target.children.push(child)
    });

    return target;
  }

  getIcon() {
    return 'fa-align-right'
  }

  connectedCallback() {
    this.innerHTML = 
      `<div class="col-sm-12 ct_action" data-action_type=HUNT_ORDER>
        <div class="panel panel-default">
          <h4>Overflow Routing</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
          <div class="form-group">
            <div class="row">
              <div class="col-md-1">
                  <label>Order</label>
              </div>
              <div class="col-md-2">
                  <label># of Seconds *</label>
              </div>
              <div class="col-md-5">
                  <label>Target</label>
              </div>
            </div>
              
            <div class="hunt_ordered_form_group"></div>
            <p>* Overflow will also happen when original target is busy or unavailable. Minimum 5 seconds.</p>
          </div>
        </div>
      </div>
      <div class="col-sm-12 ct_line">
        <div class="ct_vertical_arrow"></div>
        <div class="option_text">Sales Rep is being Called</div>
        <div class="ct_vertical_arrow">
          <div class=arrow-down></div>
        </div>
      </div>
    `;
    if(this.target == null) {
      this.querySelector(".hunt_ordered_form_group").appendChild(document.createElement("hunt-order-item"));
    }
    else {
      this.target.children.map(function(target_child, i) {
          let huntOrderItem = document.createElement("hunt-order-item");
          huntOrderItem.setChild(target_child);
          this.querySelector(".hunt_ordered_form_group").appendChild(huntOrderItem);
        }.bind(this)
      );
    }
    super.connectedCallback();
  }
}

customElements.define('hunt-order-treatment', HuntOrderTreatment);

class HuntOrderItem extends HTMLElement {
  constructor() {
    super();
  }

  setRank(rank) {
    this.querySelector('.hunt_rank').innerHTML = rank;
  }

  setChild(child) {
    this.target = child.destination;
    this.child = child;
  }

  connectedCallback() {
    this.innerHTML = 
      `<style>
        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        
        /* Firefox */
        input[type=number] {
          -moz-appearance: textfield;
        }
      </style>
      <div class="row hunt_ordered_form_item" style="margin-top: 3px;">
              <div class="col-sm-1 hunt_rank" style="font-size: 15px;font-weight: 900;padding-top: 5px;">
                ${this.child != null ? this.child.tod_rank : 1}
              </div>
              <div class="col-sm-2">
                <input type="number" class="form-control hunt_ordered_rna" data-key="hunt_ordered_rna" data-validate="number" min="5" value="${this.child != null ? this.child.tod_rna_rollover : 5}"/>
              </div>
              <div class="col-sm-5">
                  <input type="text" is="ring-to-endpoint" class="form-control hunt_ordered_ring_number" data-key="hunt_ordered_ring_number" placeholder="(123) 444-5566 or SIP Target" style="width: 80%;
                display: inline-block;" value="${this.target != null ? this.target.ring_to_endpoint : ""}"/>
                  <a href="#" class="remove_hunt_ordered" style="margin-left: 10px;"><i class="fa fa-minus"></i></a>
                  <a href="#" class="add_hunt_ordered" style="margin-left: 10px;"><i class="fa fa-plus"></i></a>
              </div>
            </div>`;

    let _this = this;
    this.querySelector(".remove_hunt_ordered").addEventListener('click', function(event) {
        event.preventDefault();
        let parent = _this.closest("hunt-order-treatment");
        _this.remove();
        parent.rerank();
      });
    this.querySelector(".add_hunt_ordered").addEventListener('click', function(event) {
        event.preventDefault();
        _this.closest("hunt-order-treatment").addNewItem();
      });
  }
}

customElements.define('hunt-order-item', HuntOrderItem);